exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack[data-v-4eb88738]{font-family:ClanFFBlack!important;font-weight:400}.clanpro[data-v-4eb88738]{font-family:ClanPro!important;font-weight:400}.clanprobold[data-v-4eb88738]{font-family:ClanProBold!important;font-weight:400}.clanprobook[data-v-4eb88738]{font-family:ClanProBook!important;font-weight:400}.warehouse-no-coordinates[data-v-4eb88738]{color:#df0321;font-weight:700;white-space:nowrap}.warehouse-no-coordinates .fa-exclamation-triangle[data-v-4eb88738]{font-size:1.15em;vertical-align:-1px}.warehouse-chronopost[data-v-4eb88738]{color:#519e5f;font-size:1.15em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4eb88738","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Warehouse/WarehouseList.vue
// module id = 816
// module chunks = 0